export function convertMetadata(libraryInfo) {
  let metaData = {
    manufacturer: "",
    model: "",
    description: "",
    creator: "",
    identifier: "",
    measurement: "",
    laboratory: "",
    report_number: "",
    report_date: "",
    creation_date: "",
    comments: "",
    spectral_quantity: ""
  };

  let libraryName = "";

  libraryInfo &&
    libraryInfo.forEach(info => {
      const infoKey = info.key;
      const infoValue = info.value;
      switch (infoKey.match(/(\d+)/)[0]) {
        case "1":
          metaData = { ...metaData, manufacturer: infoValue };
          break;
        case "2":
          metaData = { ...metaData, model: infoValue };
          libraryName = infoValue;
          break;
        case "3":
          metaData = { ...metaData, description: infoValue };
          break;
        case "4":
          metaData = { ...metaData, creator: infoValue };
          break;
        case "5":
          metaData = { ...metaData, identifier: infoValue };
          break;
        case "6":
          metaData = { ...metaData, measurement: infoValue };
          break;
        case "7":
          metaData = { ...metaData, laboratory: infoValue };
          break;
        case "8":
          metaData = { ...metaData, report_number: infoValue };
          break;
        case "9":
          metaData = { ...metaData, report_date: infoValue };
          break;
        case "10":
          metaData = { ...metaData, creation_date: infoValue };
          break;
        case "11":
          metaData = { ...metaData, comments: infoValue };
          break;
        case "12":
          metaData = { ...metaData, spectral_quantity: infoValue };
          break;
        default:
          break;
      }
    });

  return { metaData: metaData, libraryName: libraryName };
}
